import { Avatar } from 'antd';
import { Rewiew } from '..';

import styles from './index.module.scss';

interface CardProps {
  review: Rewiew;
}

const getFlagUrlFromIso2 = (iso2: string): string =>
  `https://purecatamphetamine.github.io/country-flag-icons/3x2/${iso2}.svg`;

const Card = ({
  review: {
    logoSrc,
    businesses: { name, city, country },
    description,
    user: { name: userName, photo, country: userCountry, category },
  },
}: CardProps) => {
  return (
    <div className={styles.card}>
      <div>
        <div className={styles.header}>
          {/* <div className={styles.logoWrapper}>
            <img src={logoSrc} className={styles.logo} />
          </div> */}
          <div className={styles.titleWrapper}>
            <div className={styles.title}>{name}</div>
            <div className={styles.address}>
              {[city, country].filter(Boolean).join(', ')}
            </div>
          </div>
        </div>
        <div className={styles.description}>{description}</div>
      </div>

      <div className={styles.userWrapper}>
        {/* <Avatar src={photo} /> */}
        <span className={styles.userName}>{userName}</span>
        {userCountry && (
          <img
            src={getFlagUrlFromIso2(userCountry)}
            alt="flag"
            className={styles.flag}
            width={24}
            height={16}
          />
        )}
        {/* {category && <span className={styles.category}>{category}</span>} */}
      </div>
    </div>
  );
};

export default Card;
